import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=07e37291&scoped=true&"
import script from "./ResourceItem.vue?vue&type=script&lang=js&"
export * from "./ResourceItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourceItem.vue?vue&type=style&index=0&id=07e37291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e37291",
  null
  
)

export default component.exports